<!-- <div class="divider"></div>
<div class="a0412bf9057629b8013f3048805bd6c2-links">
  <router-link to="/">Home</router-link>
  <router-link to="/bots">Bots</router-link>
  <router-link to="/dashboard/login">Dashboard</router-link>
  <router-link to="/support">Support</router-link>
  <router-link to="/tos">Terms of service</router-link>
  <router-link to="/privacy">Privacy</router-link>
</div> 

<div class="right-links">
  <a href="https://github.com/uNeffy"
    ><font-awesome-icon :icon="['fab', 'github']"
  /></a>
  <a href="https://steamcommunity.com/id/neffysteam"
    ><font-awesome-icon :icon="['fab', 'steam']"
  /></a>
</div>
-->

<template>
  <div id="app">
    <nav class="c06d727c3c6c14c6653350574230461f" data-v-7ba5bd90>
      <div class="a0412bf9057629b8013f3048805bd6c2">
        <div class="beea85bd69c2e95a6e6f09e3857bc779">
          <router-link to="/"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="245 50 20 50"
              style="background: none"
              preserveAspectRatio="xMidYMid"
              class="d1333d07adde1db62df93919c4604be8"
            >
              <defs>
                <filter
                  id="editing-hole"
                  x="-50%"
                  y="-50%"
                  width="300%"
                  height="300%"
                >
                  <feFlood flood-color="#bbcedd" result="black"></feFlood>
                  <feMorphology
                    operator="dilate"
                    radius="2"
                    in="SourceGraphic"
                    result="erode"
                  ></feMorphology>
                  <feGaussianBlur
                    in="erode"
                    stdDeviation="4"
                    result="blur"
                  ></feGaussianBlur>
                  <feOffset in="blur" dx="2" dy="2" result="offset"></feOffset>
                  <feComposite
                    operator="atop"
                    in="offset"
                    in2="black"
                    result="merge"
                  ></feComposite>
                  <feComposite
                    operator="in"
                    in="merge"
                    in2="SourceGraphic"
                    result="inner-shadow"
                  ></feComposite>
                </filter>
              </defs>
              <g filter="url(#editing-hole)">
                <g transform="translate(156.5704796910286, 97.33499908447266)">
                  <path
                    d="M7.68 0L0.64 0L8.32-42.24L22.08-42.24L32.06-13.18L37.38-42.24L44.48-42.18L36.67 0L22.02 0L12.80-27.97L7.68 0ZM73.41-9.86L73.41-9.86L73.41-9.86Q74.62-8.32 74.62-5.82L74.62-5.82L74.62-5.82Q74.62-2.37 72.06-0.54L72.06-0.54L72.06-0.54Q69.50 1.28 65.47 1.28L65.47 1.28L65.47 1.28Q63.17 1.28 59.65 0.77L59.65 0.77L59.65 0.77Q52.74-0.32 50.62-0.32L50.62-0.32L50.62-0.32Q48.51-0.32 47.68-0.22L47.68-0.22L47.68-0.22Q46.85-0.13 45.50 0L45.50 0L53.38-42.24L80.96-42.24L80.96-42.24Q80.96-38.34 79.07-36.29L79.07-36.29L79.07-36.29Q77.18-34.24 73.47-34.24L73.47-34.24L73.47-34.24Q69.76-34.24 65.98-35.97L65.98-35.97L64-24.77L75.39-24.77L75.39-24.77Q75.39-21.38 73.73-19.49L73.73-19.49L73.73-19.49Q72.06-17.60 69.28-17.60L69.28-17.60L69.28-17.60Q66.50-17.60 64.77-18.24L64.77-18.24L64.77-18.24Q63.04-18.88 62.85-19.07L62.85-19.07L60.54-6.98L60.54-6.98Q62.08-6.78 64.96-6.78L64.96-6.78L64.96-6.78Q69.89-6.78 73.41-9.86ZM109.63-33.92L109.63-33.92L109.63-33.92Q104.45-33.92 100.67-35.65L100.67-35.65L98.62-25.28L110.98-25.28L110.98-25.28Q110.98-21.89 109.28-19.74L109.28-19.74L109.28-19.74Q107.58-17.60 104.51-17.60L104.51-17.60L104.51-17.60Q101.18-17.60 98.11-18.82L98.11-18.82L98.11-18.82Q97.47-19.07 97.41-19.14L97.41-19.14L93.76 0L79.81 0L87.94-42.24L116.48-42.24L116.48-42.24Q116.48-38.34 114.66-36.13L114.66-36.13L114.66-36.13Q112.83-33.92 109.63-33.92ZM144-33.92L144-33.92L144-33.92Q138.82-33.92 135.04-35.65L135.04-35.65L132.99-25.28L145.34-25.28L145.34-25.28Q145.34-21.89 143.65-19.74L143.65-19.74L143.65-19.74Q141.95-17.60 138.88-17.60L138.88-17.60L138.88-17.60Q135.55-17.60 132.48-18.82L132.48-18.82L132.48-18.82Q131.84-19.07 131.78-19.14L131.78-19.14L128.13 0L114.18 0L122.30-42.24L150.85-42.24L150.85-42.24Q150.85-38.34 149.02-36.13L149.02-36.13L149.02-36.13Q147.20-33.92 144-33.92ZM155.78 0L159.49-18.82L159.49-18.82Q157.63-36.16 151.10-39.87L151.10-39.87L151.10-39.87Q152.45-41.54 154.62-42.46L154.62-42.46L154.62-42.46Q156.80-43.39 159.42-43.39L159.42-43.39L159.42-43.39Q162.05-43.39 164.03-42.46L164.03-42.46L164.03-42.46Q166.02-41.54 167.30-39.55L167.30-39.55L167.30-39.55Q169.73-35.78 169.73-26.75L169.73-26.75L169.73-22.14L169.73-22.14Q173.57-33.41 177.41-38.27L177.41-38.27L177.41-38.27Q181.31-43.26 186.18-43.26L186.18-43.26L186.18-43.26Q188.10-43.26 189.38-42.27L189.38-42.27L189.38-42.27Q190.66-41.28 191.30-39.81L191.30-39.81L191.30-39.81Q186.37-37.63 181.63-31.36L181.63-31.36L181.63-31.36Q176.90-25.09 173.82-16.32L173.82-16.32L170.05 0L155.78 0Z"
                    fill="#fdfdfd"
                  ></path>
                </g>
              </g>
            </svg>
          </router-link>
        </div>
        <div class="f1c858e6f3e8a96e5ff2be690ea741fe">
          <a href="https://github.com/uNeffy"
            ><font-awesome-icon :icon="['fab', 'github']"
          /></a>
          <a href="https://steamcommunity.com/id/neffysteam"
            ><font-awesome-icon :icon="['fab', 'steam']"
          /></a>
        </div>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<style scoped src="@/assets/css/navbar.css"></style>

<script>
export default {
  name: "app",
};
</script>
